import "./BooksBalanceHeader.css";
import { formatMoney } from "@/lib/format";

export interface BooksBalanceHeaderProps {
  /** The register's running balance through its most recent loaded row. */
  balance: number;
  /** Sum of every loaded row's amount where `cleared` is true. */
  clearedBalance: number;
  /** Count of loaded rows where `cleared` is false. */
  outstandingCount: number;
}

/**
 * ADR 0010 §3 — the balance headline (mock lines 38–40). Rendered into `PageHeader`'s
 * existing `action` slot from `Books.tsx`'s Entry route; every figure here is computed
 * client-side from the already-loaded register page — no new read route.
 *
 * Both figures render as a plain magnitude (`Math.abs`), never a signed amount — the
 * mock shows neither the running balance nor the cleared subtotal with a sign, and a
 * bare minus sign here would be a new, un-mocked treatment for the rare moment either
 * figure dips negative mid-suite (concurrent specs writing against the same seeded
 * account).
 */
export function BooksBalanceHeader({ balance, clearedBalance, outstandingCount }: BooksBalanceHeaderProps) {
  return (
    <div className="books-balance-header" data-state="ready">
      <span className="books-balance-header__label">Balance today</span>
      <span className="books-balance-header__figure">{formatMoney(Math.abs(balance))}</span>
      <span className="books-balance-header__sub">
        {`Cleared ${formatMoney(Math.abs(clearedBalance))} · ${outstandingCount} outstanding`}
      </span>
    </div>
  );
}
